import { UserSettings } from '@models/user-settings';
import { StateObj } from '@utils';
import { createContext, useContext } from 'react';

export const UserSettingsContext = createContext<StateObj<UserSettings> | null>(
  null,
);

export function useUserSettings(): StateObj<UserSettings> {
  const context = useContext(UserSettingsContext);
  if (!context) {
    throw new Error(
      'useUserSettings must be used within an AppInitializationProvider',
    );
  }
  return context;
}
